import Chip from "@mui/material/Chip";
import VuiBox from "components/VuiBox";
import VuiTypography from "components/VuiTypography";

const ORIGEN_LABELS = {
  numeros_rebote: "Números operativos (rebote)",
  usuarios_secundarios: "Usuarios secundarios (fallback)",
};

export function formatDisplayPhone(numero) {
  if (!numero || typeof numero !== "string") return numero || "—";
  const digits = numero.replace(/\D/g, "");
  if (digits.length === 11 && digits.startsWith("51")) {
    return `+${digits.slice(0, 2)} ${digits.slice(2, 5)} ${digits.slice(5, 8)} ${digits.slice(8)}`;
  }
  return numero;
}

export default function NotificationRecipientsSummary({ recipients, compact = false }) {
  const data = recipients || {};
  const destinatarios = data.destinatarios || [];
  const origenLabel = ORIGEN_LABELS[data.origen] || null;
  const usingSecundariosFallback =
    data.origen === "usuarios_secundarios" || (data.sin_rebote && destinatarios.length > 0);

  if (!destinatarios.length) {
    return (
      <VuiTypography variant="caption" color="text" display="block">
        {data.rebote_count > 0
          ? "Hay números de rebote pero ninguno es válido para alertas"
          : data.secundarios_count > 0
            ? "Hay usuarios secundarios pero ninguno tiene celular válido"
            : "Sin rebote ni secundarios activos para alertas"}
      </VuiTypography>
    );
  }

  if (compact) {
    const preview = destinatarios
      .slice(0, 2)
      .map((d) => formatDisplayPhone(d.numero))
      .join(", ");
    const extra = destinatarios.length > 2 ? ` +${destinatarios.length - 2}` : "";
    return (
      <VuiTypography variant="caption" sx={{ color: "#01B574" }} display="block">
        Alertas: {preview}
        {extra}
      </VuiTypography>
    );
  }

  return (
    <VuiBox>
      {usingSecundariosFallback && (
        <VuiTypography variant="caption" color="text" display="block" mb={1}>
          No hay números de rebote. Las alertas se enviarán a los usuarios secundarios:
        </VuiTypography>
      )}
      {origenLabel && !usingSecundariosFallback && (
        <VuiBox display="flex" alignItems="center" gap={1} mb={1}>
          <VuiTypography variant="caption" color="text" fontWeight="medium">
            Origen:
          </VuiTypography>
          <Chip label={origenLabel} size="small" color="info" variant="outlined" />
        </VuiBox>
      )}
      <VuiTypography variant="caption" color="text" fontWeight="medium" display="block" mb={0.5}>
        {usingSecundariosFallback ? "Usuarios secundarios:" : "Recibirán las notificaciones:"}
      </VuiTypography>
      {destinatarios.map((dest) => (
        <VuiBox key={dest.numero} mb={0.5}>
          {dest.label ? (
            <>
              <VuiTypography
                variant="button"
                fontWeight="bold"
                display="block"
                sx={{ color: "#FFFFFF", lineHeight: 1.4 }}
              >
                {dest.label}
              </VuiTypography>
              <VuiTypography
                variant="caption"
                display="block"
                sx={{ color: "rgba(203, 213, 225, 0.92)" }}
              >
                {formatDisplayPhone(dest.numero)}
              </VuiTypography>
            </>
          ) : (
            <VuiTypography
              variant="button"
              fontWeight="medium"
              sx={{ color: "#FFFFFF", lineHeight: 1.4 }}
            >
              {formatDisplayPhone(dest.numero)}
            </VuiTypography>
          )}
        </VuiBox>
      ))}
    </VuiBox>
  );
}
